<template>
  <b-row>
    <b-col sm="12">

      <b-card body-class="py-2">
        <section class="list-view-heading" v-if="php">
          <div class="view-php-custom-heading d-none d-md-flex">
            <span class="view-php-custom-heading__icon"><AppIcon name="external" /></span>
            <p class="view-php-custom-heading__text" v-if="php.observations">{{php.observations}}</p>
          </div>
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card no-body class="card-view-php-custom">
        <iframe v-if="php"
                ref="customIframe"
                :src="php.external_url"
                allowfullscreen
                frameborder="0"
                class="view-php-custom-iframe"
                :style="iframeHeight ? { height: iframeHeight + 'px' } : null"
        ></iframe>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>
        </div>
      </b-card>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import { EventBus } from '@/handler/event-bus'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PHP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'viewPHPCustom',
          elements: {}
        },
        php: null,
        iframeHeight: null,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.load()
      this._start = true
      window.addEventListener('message', this.onInterfaceResizeMessage)
    },
    activated() {
      if(this._start) {
        this._start = false
        return
      }
      this.load()
    },
    beforeDestroy() {
      window.removeEventListener('message', this.onInterfaceResizeMessage)
    },
    methods: {
      load() {
        if(!this.$route.params.id) {
          this.$router.go(-1)
        }

        const id = this.$route.params.id
        var result = serviceAPI.mostrarPHP(id)

        result.then((response) => {
          var data = response.data

          this.php = data
          EventBus.$emit('Update:TabMetadata', {
            title: this.php.name,
            subtitle: this.php.observations,
            icon: 'external',
          })
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
      onInterfaceResizeMessage(event) {
        if(!event.data || event.data.source !== 'php-interface-resize') return

        const iframeEl = this.$refs.customIframe
        if(!iframeEl || event.source !== iframeEl.contentWindow) return

        // Se compara siempre contra el alto mínimo por viewport (no contra
        // el alto ya ajustado), para que un contenido que reduce su altura
        // no quede "pisado" por un valor grande que ya no corresponde.
        const minHeight = Math.max(window.innerHeight - 260, 320)
        this.iframeHeight = event.data.height > minHeight ? event.data.height : null
      },
    }
  }
</script>
<style scoped>
  .view-php-custom-heading {
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    gap: 8px;
    min-height: 36px;
    min-width: 0;
    width: auto;
  }
  .view-php-custom-heading__icon {
    align-items: center;
    background: var(--app-color-primary-soft);
    border-radius: 8px;
    color: var(--app-color-primary);
    display: inline-flex;
    flex: 0 0 28px;
    font-size: 0.85rem;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
  .view-php-custom-heading__text {
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-medium);
    margin: 0;
  }

</style>
<style>
  .view-php-custom-iframe {
    border: 0;
    display: block;
    height: calc(100vh - 260px);
    min-height: 320px;
    width: 100%;
  }
</style>
